// src/pages/news/AppointmentModalUpdate.js
import React from 'react';
import { Link } from 'react-router-dom';
import './AppointmentModalUpdate.css';
import newVisitModal from '../../assets/images/news/new_visit_modal.png';

const AppointmentModalUpdate = () => {
  return (
    <div className="appointment-modal-update">
      <div className="container">
        <div className="info-card">
          <div className="info-header">
            <div className="info-icon">
              <i className="fas fa-columns"></i>
            </div>
            <h1>Update: Appointment Modal Design</h1>
            <div className="feature-badge">NEW UI</div>
          </div>

          <div className="info-content">
            <div className="feature-description">
              <h2>Same Functionality, Cleaner Layout</h2>
              <p>
                We have redesigned the Appointment modal to use <strong>tabs</strong> instead of the long
                scrolling form. <strong>No functionality has changed</strong> — everything works exactly the same,
                it just looks cleaner and is easier to navigate.
              </p>
            </div>

            <div className="screenshot-section">
              <div className="screenshot-frame">
                <img src={newVisitModal} alt="New appointment modal with tabs" />
              </div>
              <div className="screenshot-caption">
                The new tabbed design organizes fields into clear sections for faster data entry.
              </div>
            </div>

            <div className="benefits-section">
              <h3>What Changed:</h3>
              <ul className="benefits-list">
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span>Tabbed interface replaces the long form</span>
                </li>
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span>All existing fields and actions are still available</span>
                </li>
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span>Faster navigation between sections without scrolling</span>
                </li>
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span>Cleaner, more focused layout</span>
                </li>
              </ul>
            </div>

            <div className="how-to-section">
              <h3>New Fees Tab</h3>
              <div className="steps">
                <div className="step">
                  <div className="step-number">1</div>
                  <div className="step-content">
                    <h4>Per-Visit Fee</h4>
                    <p>
                      Each appointment can now have its <strong>own fee</strong> in the <strong>Fees</strong> tab.
                      If you leave it blank, we will automatically use your default Doctor Fee
                      from the <strong>Profile</strong> page.
                    </p>
                  </div>
                </div>
                <div className="step">
                  <div className="step-number">2</div>
                  <div className="step-content">
                    <h4>No Extra Steps</h4>
                    <p>
                      This is an optional field. If you do nothing, the system uses your profile fee
                      - no workflow changes required.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="action-buttons">
              <Link to="/control/appointments" className="primary-btn">
                <i className="fas fa-calendar-alt"></i>
                Go to Appointments
              </Link>
              <Link to="/control/doctor-information" className="secondary-btn">
                <i className="fas fa-user-md"></i>
                Update Profile Fee
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentModalUpdate;
